// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__4E8dg","inner":"Footer_inner__-i+9q"};